<svg [attr.width]="size"
     [attr.height]="size"
     viewBox="0 0 24 24"
     fill="none"
     stroke="currentColor"
     stroke-width="2"
     stroke-linecap="round"
     stroke-linejoin="round"
     aria-hidden="true">
    <ng-container [ngSwitch]="icon">
        <ng-container *ngSwitchCase="'muscle'">
            <path d="M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1"></path>
            <path d="M15 14a5 5 0 0 0-7.584 2"></path>
            <path d="M9.964 6.825C8.019 7.977 9.5 13 8 15"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'equipment'">
            <path d="M17.596 12.768a2 2 0 1 0 2.829-2.829l-1.768-1.767a2 2 0 0 0 2.828-2.829l-2.828-2.828a2 2 0 0 0-2.829 2.828l-1.767-1.768a2 2 0 1 0-2.829 2.829z"></path>
            <path d="m2.5 21.5 1.4-1.4"></path>
            <path d="m20.1 3.9 1.4-1.4"></path>
            <path d="M5.343 21.485a2 2 0 1 0 2.829-2.828l1.767 1.768a2 2 0 1 0 2.829-2.829l-6.364-6.364a2 2 0 1 0-2.829 2.829l1.768 1.767a2 2 0 0 0-2.828 2.829z"></path>
            <path d="m9.6 14.4 4.8-4.8"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'level'">
            <path d="M12 20V10"></path>
            <path d="M18 20V4"></path>
            <path d="M6 20v-4"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'location'">
            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
            <circle cx="12" cy="10" r="3"></circle>
        </ng-container>
        <ng-container *ngSwitchCase="'tag'">
            <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
            <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
        </ng-container>
        <ng-container *ngSwitchCase="'status'">
            <circle cx="12" cy="16" r="1"></circle>
            <rect width="18" height="12" x="3" y="10" rx="2"></rect>
            <path d="M7 10V7a5 5 0 0 1 9.33-2.5"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'check-circle'">
            <circle cx="12" cy="12" r="9"></circle>
            <path d="m8.5 12.2 2.4 2.4 4.6-5"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'structure'">
            <rect width="7" height="7" x="3" y="3" rx="1"></rect>
            <rect width="7" height="7" x="14" y="3" rx="1"></rect>
            <rect width="7" height="7" x="14" y="14" rx="1"></rect>
            <rect width="7" height="7" x="3" y="14" rx="1"></rect>
        </ng-container>
        <ng-container *ngSwitchCase="'type'">
            <path d="M4 7V4h16v3"></path>
            <path d="M9 20h6"></path>
            <path d="M12 4v16"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'duration'">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M12 6v6l4 2"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'calendar'">
            <path d="M8 2v4"></path>
            <path d="M16 2v4"></path>
            <rect width="18" height="18" x="3" y="4" rx="2"></rect>
            <path d="M3 10h18"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'stage'">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
            <circle cx="12" cy="12" r="3"></circle>
        </ng-container>
        <ng-container *ngSwitchCase="'category'">
            <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z"></path>
        </ng-container>
        <ng-container *ngSwitchCase="'stretch-horizontal'">
            <rect width="20" height="6" x="2" y="4" rx="2"></rect>
            <rect width="20" height="6" x="2" y="14" rx="2"></rect>
        </ng-container>
        <ng-container *ngSwitchCase="'goal'">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
        </ng-container>
        <ng-container *ngSwitchCase="'layout-panel-top'">
            <rect width="18" height="7" x="3" y="3" rx="1"></rect>
            <rect width="7" height="7" x="3" y="14" rx="1"></rect>
            <rect width="7" height="7" x="14" y="14" rx="1"></rect>
        </ng-container>
        <ng-container *ngSwitchCase="'target'">
            <circle cx="12" cy="12" r="10"></circle>
            <circle cx="12" cy="12" r="6"></circle>
            <circle cx="12" cy="12" r="2"></circle>
        </ng-container>
        <ng-container *ngSwitchCase="'book'">
            <path d="M12 7v14"></path>
            <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path>
        </ng-container>
    </ng-container>
</svg>
